import { Container as MContainer, ContainerProps } from '@mui/material'

export const Container: React.FC<ContainerProps> = (props) => {
  return <MContainer {...props} />
}
